import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  width: ${({ $small }) => ($small ? "1rem" : "1.25rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithoutRef<"svg"> {
  small?: boolean;
  className?: string;
}

// FUNCTIONS

// ASSETS
